import * as React from 'react';
import type { SVGProps } from 'react';
interface Props extends SVGProps<SVGSVGElement> {
  height?: number;
  width?: number;
  fill?: string;
}

const SvgMemberCopy = ({ width = 24, height = 24, ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="currentColor"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.286 7.688a3.813 3.813 0 1 1 7.625 0 3.813 3.813 0 0 1-7.625 0ZM12.098 2a5.688 5.688 0 1 0 0 11.376 5.688 5.688 0 0 0 0-11.376Zm0 12.35C7.267 14.35 3 17.574 3 21.94a.937.937 0 1 0 1.875 0c0-2.988 3.049-5.713 7.223-5.713 4.175 0 7.224 2.725 7.224 5.713a.938.938 0 0 0 1.875 0c0-4.366-4.267-7.588-9.098-7.588Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMemberCopy;
